webpackJsonp([236556718474903],{

/***/ 643:
/***/ (function(module, exports) {

	module.exports = {"data":{"projectsJson":{"name":"92Y","keywords":["Unity","iOS","360","Oculus Rift","VR","cross-platform","Cinema 4D "],"status":["shipped","green"],"tagline":"An iOS and Oculus Rift app built for 92Y internal use.","year":[2016,2017],"description":"We (*Click 3X*) created an immersive 360 Experience for [92Y](https://www.92y.org/) and their capital campaign.\n\nWe produced a bunch of 360 videos, and **I was tasked with wrapping them up into an iOS app and an Oculus Rift app.**\n\nI used Unity for creating both apps. I *also* got to mess around with Cinema 4D to create geometry for the VR user interface.","images":["92Y.png-noShadow"],"videos":null,"id":"/Users/davidbaker/code/davidbaker.is/src/data/projects.json absPath of file [7] >>> JSON","logo":null,"link":null,"linkToSource":null,"linkToTrello":null,"callToAction":null,"teammates":null,"agency":{"name":"Click 3X","link":"http://click3x.com/"}}},"pathContext":{"projectPath":"lost-in-virtual-reality"}}

/***/ })

});


// WEBPACK FOOTER //
// path---lost-in-virtual-reality-6c42d656bc7103a4dc37.js